import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { VideoComponent } from './componentes/video/video.component';
import { GaleriaComponent } from './componentes/galeria/galeria.component';
import { HomeComponent } from './componentes/home/home.component';


const routes: Routes = [
  {path: '', redirectTo:'Home', pathMatch:'full'},
  {path: 'contactos', component: VideoComponent},
  {path: 'videos', component: GaleriaComponent},
  {path: 'Home', component: HomeComponent}
];

@NgModule({

  imports: [
    RouterModule.forRoot(routes,  { useHash: true }),
    BrowserModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
